import { toast } from "react-toastify";
import { getRoute } from "../api/routes";
import api from "../Interceptor";
import { useEffect, useState } from "react";

const TogalsSetup = () => {
  const userId = localStorage.getItem("id");

  const [notifyOnProject, setNotifyOnProject] = useState(true);
  const [notifyOnExpense, setNotifyOnExpense] = useState(true);
  const [loadingProject, setLoadingProject] = useState(false);
  const [loadingExpense, setLoadingExpense] = useState(false);

  // ✅ Initialize from localStorage
  useEffect(() => {
    const projectVal = localStorage.getItem("notifyOnProject");
    const expenseVal = localStorage.getItem("notifyOnExpense");

    if (projectVal !== null) {
      setNotifyOnProject(projectVal === "true");
    }

    if (expenseVal !== null) {
      setNotifyOnExpense(expenseVal === "true");
    }
  }, []);

  // ===============================
  // Project Email Toggle
  // ===============================
  const handleProjectEmailToggle = async () => {
    const nextValue = !notifyOnProject;

    try {
      setLoadingProject(true);

      await api.patch(`/admin/getEmail/users/${userId}/notify-project`, {
        notifyOnProject: nextValue,
      });

      setNotifyOnProject(nextValue);
      localStorage.setItem("notifyOnProject", nextValue);

      toast.success("Project email notification updated");
    } catch (error) {
      toast.error("Failed to update project notifications");
      console.error(error);
    } finally {
      setLoadingProject(false);
    }
  };

  // ===============================
  // Expense Email Toggle
  // ===============================
  const handleExpenseEmailToggle = async () => {
    const nextValue = !notifyOnExpense;

    try {
      setLoadingExpense(true);

      await api.patch(`/admin/getEmail/users/${userId}/notify-expense`, {
        notifyOnExpense: nextValue,
      });

      setNotifyOnExpense(nextValue);
      localStorage.setItem("notifyOnExpense", nextValue);

      toast.success("Expense email notification updated");
    } catch (error) {
      toast.error("Failed to update expense notifications");
      console.error(error);
    } finally {
      setLoadingExpense(false);
    }
  };

  return (
    <div className="flex w-full gap-2">
      {/* Expense Toggle */}
      <div className="bg-gray-50 rounded-xl p-2 w-1/2">
        <div className="flex justify-between items-center">
          <p className="text-md">Send Email on Every New Transaction</p>

          <button
            onClick={handleExpenseEmailToggle}
            disabled={loadingExpense}
            className={`relative inline-block w-12 h-6 rounded-full transition-colors duration-300
            ${notifyOnExpense ? "bg-green-500" : "bg-gray-400"}
            ${loadingExpense ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
          `}
          >
            <span
              className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300
              ${notifyOnExpense ? "translate-x-6 left-1" : "translate-x-0 left-1"}
            `}
            />
          </button>
        </div>
      </div>

      {/* Project Toggle */}
      <div className="bg-gray-50 rounded-xl p-2 w-1/2">
        <div className="flex justify-between items-center">
          <p className="text-md">Send Email on Every New Project Addition</p>

          <button
            onClick={handleProjectEmailToggle}
            disabled={loadingProject}
            className={`relative inline-block w-12 h-6 rounded-full transition-colors duration-300
            ${notifyOnProject ? "bg-green-500" : "bg-gray-400"}
            ${loadingProject ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}
          `}
          >
            <span
              className={`absolute top-1 w-4 h-4 bg-white rounded-full transition-transform duration-300
              ${notifyOnProject ? "translate-x-6 left-1" : "translate-x-0 left-1"}
            `}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TogalsSetup;
